import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { CartTable } from "./components";
import { useSelector, useDispatch } from "react-redux";
import { updateCart } from "../../redux-store/shop/shop";
import { Container } from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Cart() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.shop);
  const { cart } = state;
  useEffect(() => {
    // console.log({'State in Cart': state})
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>Cart - d2p</title>
      </Helmet>
      <ToastContainer></ToastContainer>
      <PageBanner title="Cart" image="./assets/images/banner.png" />
      <Container>
        <CartTable cart={cart} updateCart={updateCart} />
      </Container>
    </Fragment>
  );
}

export default Cart;
